import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

// Global CSS (already loaded in index.js)
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";
import ScrollToTopButton from "./components/ScrollToTopButton/ScrollToTopButton";
import Home from "./pages/Home";
import AboutUs from "./components/AboutUs/AboutUs";
import Products from "./pages/Products/Products";
import ProductDetailPage from "./pages/Products/ProductDetailPage";
import Catalog from "./pages/Catalog/Catalog";
import CatalogForm from "./pages/Catalog/CatalogForm";
import CatalogManagement from "./pages/Catalog/CatalogManagement";
import Contact from "./components/Contact/Contact";
import Login from "./pages/Login/Login";
import ProductForm from "./pages/ProductManagement/ProductForm";
import ProductManagement from "./pages/ProductManagement/ProductManagement";
import ProductOrdering from "./pages/ProductManagement/ProductOrdering";
import EnglishProductForm from "./pages/ProductManagement/EnglishProductForm";
import EnglishProductManagement from "./pages/ProductManagement/EnglishProductManagement";
import Documents from "./pages/Document/Documents";
import DocumentsForm from "./pages/Document/DocumentsForm";
import DocumentsManagement from "./pages/Document/DocumentsManagement";
import PrivateRoute from "./components/PrivateRoute";
import UnderConstruction from "./pages/English/UnderConstruction";
import { AuthProvider } from "./authContetxt";
import { LanguageProvider } from "./contexts/LanguageContext";
import useIdleAutoLogout from "./hooks/useIdleAutoLogout";

// Import test function for debugging (only in development)
if (process.env.NODE_ENV === "development") {
  import("./testApiConnection");
}

function IdleLogoutWrapper() {
  useIdleAutoLogout({ idleMinutes: 30, pingThrottleMs: 60_000 }); // 1 min for testing
  return null;
}


const App = () => {
  // Initialize AOS once when component mounts
  useEffect(() => {
    AOS.init({ duration: 1000, once: true, offset: 0 });
  }, []);

  return (
    <LanguageProvider>
      <AuthProvider>
        <IdleLogoutWrapper />
        <ScrollToTop />
        <ScrollToTopButton />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetailPage />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/add-product" element={<ProductForm />} />
          <Route path="/add-english-product" element={<EnglishProductForm />} />
          <Route
            path="/manage-products"
            element={
              <PrivateRoute>
                <ProductManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/manage-english-products"
            element={
              <PrivateRoute>
                <EnglishProductManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/order-products"
            element={
              <PrivateRoute>
                <ProductOrdering />
              </PrivateRoute>
            }
          />
          <Route path="/add-catalog" element={<CatalogForm />} />
          <Route path="/documents" element={<Documents />} />
          <Route path="/add-documents" element={<DocumentsForm />} />
          <Route path="/manage-documents" element={<DocumentsManagement />} />
          <Route
            path="/manage-catalogs"
            element={
              <PrivateRoute>
                <CatalogManagement />
              </PrivateRoute>
            }
          />
          <Route path="/en" element={<UnderConstruction />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </AuthProvider>
    </LanguageProvider>
  );
};

// 2) Fallback NotFound
const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: "50px", textAlign: "center" }}>
      <h1>{t("not_found.title")}</h1>
      <p>{t("not_found.message")}</p>
    </div>
  );
};

export default App;
